import { render } from "./add-shipment-id.vue?vue&type=template&id=157d290b&ts=true"
import script from "./add-shipment-id.vue?vue&type=script&lang=ts"
export * from "./add-shipment-id.vue?vue&type=script&lang=ts"

import "./add-shipment-id.vue?vue&type=style&index=0&id=157d290b&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__